var whro = whro || {};
whro.util = whro.util || {};


/*================================================================================	
		serializeParams (to handle the search filters in the URL)
		1. select only the attributes we want to display in the URL (i.e. page, and filter criterion);
		2. remove the attributes with no values: if the filter criterion is empty (because it's been erased), the 'criterion' attribute shouldn't be in the URL;
		3. join each key-value pair with a ':', so we'd obtain (e.g.) 'page:3'
		4. join all the pairs together with a '+', so we'd end up with (e.g.) 'page:3+criterion:ck'.
		
		The functions you don't recognize are from underscore.js
	 ================================================================================*/
whro.util.serializeParams = function(o){
	o = _.pick(o, "page");
	
	/* remvoe anything that isn't set so we don't clutter up the url */
	var filtered = _.filter(_.pairs(o), function(pair){ return pair[1]; } )
	return (_.map(filtered, function(pair){ return pair.join(":"); })).join('+');
}

/* basically, reverse the serializeParams function above */
whro.util.parseParams = function(params){

	var options = {};
	if(params && params.trim() !==''){
		params = params.split('+');
		_.each(params, function(param){
			var values = param.split(':');
			if(values[1]){
				options[values[0]] = values[1];
			}
		});
	}
	//_.defaults(options, {page:1});
	return options;
}